var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-button',{on:{"iconClicked":_vm.onCloseClick}},[_c('img',{attrs:{"src":"/close.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }